(function () {
  if (customElements.get('product-sticky-buy')) return;

  customElements.define(
    'product-sticky-buy',
    class ProductStickyBuy extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.proxyButton = this.querySelector('.product-sticky-buy__button');
        this.label = this.querySelector('.product-sticky-buy__label');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.mainButtonVisible = false;

        if (
          !this.productInfo ||
          this.productInfo.dataset.updateUrl !== 'true' ||
          !this.proxyButton ||
          !this.resolveMainButton()
        ) {
          return;
        }

        this.onProxyClick = this.handleProxyClick.bind(this);
        this.onViewportChange = this.updateVisibility.bind(this);
        this.proxyButton.addEventListener('click', this.onProxyClick);

        if (typeof this.mobileQuery.addEventListener === 'function') {
          this.mobileQuery.addEventListener('change', this.onViewportChange);
        } else {
          this.mobileQuery.addListener(this.onViewportChange);
        }

        this.buttonObserver = new MutationObserver(() => {
          this.syncFromMainButton();
          this.updateVisibility();
        });
        this.buttonObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
          childList: true,
          subtree: true,
        });

        if ('IntersectionObserver' in window) {
          this.intersectionObserver = new IntersectionObserver(
            (entries) => {
              this.mainButtonVisible = entries.some((entry) => entry.isIntersecting);
              this.updateVisibility();
            },
            { threshold: 0.01 }
          );
          this.intersectionObserver.observe(this.mainButton);
        } else {
          this.onScroll = () => {
            this.mainButtonVisible = this.isMainButtonInViewport();
            this.updateVisibility();
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
        }

        this.hidden = false;
        this.mainButtonVisible = this.isMainButtonInViewport();
        this.syncFromMainButton();
        this.updateVisibility();
      }

      disconnectedCallback() {
        this.proxyButton?.removeEventListener('click', this.onProxyClick);
        this.buttonObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);

        if (this.mobileQuery && this.onViewportChange) {
          if (typeof this.mobileQuery.removeEventListener === 'function') {
            this.mobileQuery.removeEventListener('change', this.onViewportChange);
          } else {
            this.mobileQuery.removeListener(this.onViewportChange);
          }
        }

        this.classList.remove('is-visible');
        this.updateBodyOffset();
      }

      resolveMainButton() {
        var buttonId = this.dataset.mainButtonId;
        this.mainButton = buttonId ? document.getElementById(buttonId) : null;
        return this.mainButton;
      }

      isMainButtonInViewport() {
        if (!this.mainButton) return false;
        var rect = this.mainButton.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < window.innerHeight;
      }

      isMainButtonDisabled() {
        return (
          !this.mainButton ||
          this.mainButton.disabled ||
          this.mainButton.getAttribute('aria-disabled') === 'true'
        );
      }

      syncFromMainButton() {
        if (!this.resolveMainButton()) return;
        var mainLabel = this.mainButton.querySelector('span');
        if (mainLabel && this.label) {
          this.label.textContent = mainLabel.textContent.trim();
        }
        this.proxyButton.disabled = this.isMainButtonDisabled();
      }

      updateVisibility() {
        this.syncFromMainButton();
        var shouldShow =
          this.mobileQuery.matches &&
          !this.mainButtonVisible &&
          !this.isMainButtonDisabled();

        this.classList.toggle('is-visible', shouldShow);
        this.proxyButton.tabIndex = shouldShow ? 0 : -1;
        this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        this.updateBodyOffset();
      }

      updateBodyOffset() {
        document.body.classList.toggle(
          'has-product-sticky-buy',
          Boolean(document.querySelector('product-sticky-buy.is-visible'))
        );
      }

      handleProxyClick() {
        this.syncFromMainButton();
        if (this.isMainButtonDisabled()) return;
        this.mainButton.click();
      }
    }
  );
})();
